import {
  Media,
  MediaPickerComponent,
  WorkspaceAsset,
} from '@gripp/shared-logic';
import { HeaderCoverImage } from '../headerCoverImage';

type AssetHeaderImageProps = {
  assetCoverImage: Media;
  imgSize?: number;
  timeoutMs?: number;
  maxRetries?: number;
  retryDelay?: number;
  invalidateQuery?: () => void;
  workspaceAsset: WorkspaceAsset;
  mediaPicker?: MediaPickerComponent;
  onImagePress?: () => void;
};

export const AssetHeaderImage = (props: AssetHeaderImageProps) => {
  return (
    <HeaderCoverImage
      media={props.assetCoverImage}
      imgSize={props.imgSize}
      timeoutMs={props.timeoutMs}
      maxRetries={props.maxRetries}
      retryDelay={props.retryDelay}
      invalidateQuery={props.invalidateQuery}
      iconName="qrcode"
      workspaceAsset={props.workspaceAsset}
      mediaPicker={props.mediaPicker}
      onImagePress={props.onImagePress}
    />
  );
};
